module.exports = __webpack_public_path__ + "static/media/icon3.62fe4f3f.svg";